import React from "react"
import { OutletStoreDetailContainer } from "containers"

const OutletStoreDetailBlock = props => <OutletStoreDetailContainer {...props} />

OutletStoreDetailBlock.displayName = "OutletDetail" // @CMS-CHANGE OutletDetail => OutletStoreDetailBlock

export default OutletStoreDetailBlock



// WEBPACK FOOTER //
// ./src/blocks/outlet-store-detail/index.jsx